import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getDecryptedUserFromCookie } from "./utils/getCookie";
import { usePermissions } from "../context/PermissionContext";

function ProtectedRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = getDecryptedUserFromCookie("gta_mainstateuser") || "";
  const userLoggedIn = isAuthenticated && isAuthenticated?.emplyee_ID;
  const { canAccessPath } = usePermissions();

  if (!userLoggedIn) return <Navigate to="/login" />;

  if (!canAccessPath(location.pathname)) {
    return <Navigate to="/" replace state={{ accessDenied: true }} />;
  }

  return children;
}

export default ProtectedRoute;
